import { Injectable, Type } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import {
    QUERY_PARAMS,
    BASE_CONSTANTS,
    // TCI_APP_DETAIL_MENU_TYPE,
    AbstractTCITenantComponentOptions,
    TCITenantAppType,
    TCITenantAppDetailsMenu,
    ITCITenantComponentOptions
} from "@tci/common";

import { ITCITenantNotAvailableParams } from "../../ng-tenants-not-available/ng-tenants-not-available.component";
import { TCITenantMenuServices } from "../../ng-tenant/tci-tenant.menu";

import { getAllMenuComponents } from "../ng-util/tools";
import { Observable } from "rxjs";
import * as lodash from "lodash";

type TciTenantGuadMenuType = Type<AbstractTCITenantComponentOptions<any>>;

@Injectable()
export class NgTenantsGuardService implements CanActivate {
    private requestedTCIMenuTypeComponents: TciTenantGuadMenuType;
    // tslint:disable-next-line: max-line-length
    private menuItemsFn: (arg: TCITenantAppType | ITCITenantComponentOptions<any>) => Observable<ITCITenantComponentOptions<string | number>[]>;
    private checkTenant = true;

    constructor(private router: Router, private tenantMenuSrv: TCITenantMenuServices) {
    }

    public setTCIMenuTypeComponents(menuTypeComponents: TciTenantGuadMenuType) {
        this.requestedTCIMenuTypeComponents = menuTypeComponents;
    }

    public setMenuItemsFn(fn: (...args) => Observable<ITCITenantComponentOptions<string | number>[]>) {
        this.menuItemsFn = fn;
    }

    public setCheckTenant(val: boolean) {
        this.checkTenant = val;
    }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        while (route.firstChild) {
            route = route.firstChild;
        }

        const params: any = route.params;
        const queryParams: any = route.queryParams;
        const commonErrorData: ITCITenantNotAvailableParams = lodash.assign({}, params, queryParams);

        // Evaluate the existing params
        if (lodash.isEmpty(params) && lodash.isEmpty(queryParams)) {
            console.warn("Tenant Guard: No params nor Tenant type present");
            return this.navigateToError(commonErrorData);
        }

        let type: TCITenantAppType;
        if (this.checkTenant) {
            const requiredTenant = queryParams[QUERY_PARAMS.APP_TYPE];
            if (!requiredTenant) { // If no tenant is specified
                console.warn("Tenant Guard: No tenant type defined on the route");
                return this.navigateToError(commonErrorData);
            } else {
                type = TCITenantAppType.fromString(requiredTenant);
                if (!type) { // If the tenant does not exist
                    console.warn("Tenant Guard: No match found for given tenant");
                    return this.navigateToError(commonErrorData);
                }
            }
        }

        const requiredComponent = params["routeid"];
        if (requiredComponent !== QUERY_PARAMS.DEFAULT_ROUTE) { // Skip component verification if it's "default" constant
            commonErrorData[QUERY_PARAMS.COMPONENT] = requiredComponent;
            const TCIMenuRequestedComp = getAllMenuComponents()
                .filter(menuItem => menuItem instanceof this.requestedTCIMenuTypeComponents)
                .find(menuItem => menuItem.getRouteId() === requiredComponent);

            // If route have invalid component routeId
            if (!TCIMenuRequestedComp) {
                console.warn("Tenant Guard: The requested component does not exist");
                return this.navigateToError(commonErrorData);
            }

            return this.menuItemsFn(type || TCIMenuRequestedComp)
                .map((comps: TCITenantAppDetailsMenu[]) => !!comps.find(comp => comp.getRouteId() === requiredComponent));
        } else {
            return true;
        }
    }

    private navigateToError(queryParams: ITCITenantNotAvailableParams): boolean {
        console.warn("Redirecting: ", queryParams);
        this.router.navigate([BASE_CONSTANTS.TENANTS_NOT_AVAILABLE], { queryParams });
        return false;
    }
}
